module.exports = __webpack_public_path__ + "assets/img/activity-time-e7bb8edb.png";